var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAndusFooterLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    role: "img",
    "aria-label": "Location",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.5a7.5 7.5 0 0 0-7.5 7.5c0 5.8 7.5 11.5 7.5 11.5s7.5-5.7 7.5-11.5A7.5 7.5 0 0 0 12 2.5Z",
    fill: "none",
    stroke: "#FF2775",
    strokeWidth: 1.6,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 10,
    r: 2.5,
    fill: "none",
    stroke: "#FF2775",
    strokeWidth: 1.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndusFooterLocation);
export default __webpack_public_path__ + "static/media/andus-footer-location.c2727691ace4b90a32c1ce9b0f462ef8.svg";
export { ForwardRef as ReactComponent };